import type { Conversation } from '@unburden/common';
import { formatDistance } from 'date-fns';

interface ConversationListProps {
  conversations: Conversation[];
  selectedConversation: Conversation | null;
  onSelect: (conversation: Conversation) => void;
  loading: boolean;
}

export function ConversationList({
  conversations,
  selectedConversation,
  onSelect,
  loading,
}: ConversationListProps) {
  if (loading && conversations.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <p className="text-gray-500">Loading conversations...</p>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <p className="text-gray-500">No conversations found</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto min-h-0">
      <ul className="divide-y divide-gray-200">
        {conversations.map((conversation) => (
          <li key={conversation.id}>
            <button
              onClick={() => onSelect(conversation)}
              className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition ${
                selectedConversation?.id === conversation.id ? 'bg-blue-50' : ''
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {conversation.name || conversation.participants.join(', ')}
                  </p>
                  <p className="text-xs text-gray-500">
                    {conversation.messageCount} messages
                  </p>
                </div>
                <div className="ml-2 flex-shrink-0">
                  <p className="text-xs text-gray-500">
                    {formatDistance(conversation.lastMessageTime * 1000, new Date(), {
                      addSuffix: true,
                    })}
                  </p>
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
